import React from "react";
import { Lightbulb } from "lucide-react";
import DashboardCard from "../components/DashboardCard";
import {
  OWNER_EXCLUSIVE_SERVICES,
} from "../constants/ownerExclusiveServices";
import OwnerServiceCard from "./OwnerServiceCard";

interface ExclusiveOwnerServicesProps {
  smDown: boolean;
  lgDown?: boolean;
}

export default function ExclusiveOwnerServices({
  smDown,
  lgDown = false,
}: ExclusiveOwnerServicesProps) {
  const padding = smDown ? "0.875rem" : lgDown ? "1rem" : "1.125rem";

  return (
    <DashboardCard padding={padding}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <Lightbulb className="h-5 w-5 shrink-0 text-[#6ea8ff]" />
              <h2 className="text-base font-bold text-[#f0f6fc] sm:text-lg">
                Soluções exclusivas para proprietários
              </h2>
            </div>
            <p className="mt-2 max-w-3xl text-xs leading-relaxed text-[#8b949e] sm:text-sm">
              Aproveite serviços disponíveis para clientes da 7Cantos e encontre soluções
              financeiras, proteção para seu patrimônio e economia no dia a dia.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
          {OWNER_EXCLUSIVE_SERVICES.map((service) => (
            <OwnerServiceCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </DashboardCard>
  );
}
